module.exports = __webpack_public_path__ + "img/slidebar-bg.11892743.png";